import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Swiper, SwiperSlide } from 'swiper/react';
import Product from '../../components/Product';
import type { Category as CategoryType, AdviceResponse } from '../../types/product';

interface Props {
  category: CategoryType;
  allowedProducts: string[];
  adviceResponseObject: AdviceResponse;
}

const Category = ({ category, allowedProducts, adviceResponseObject }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const productsToDisplay = category.products.filter((pid) => allowedProducts.includes(pid));
  if (productsToDisplay.length <= 0) return <></>;

  const visibleProducts = isOpen ? productsToDisplay : productsToDisplay.slice(0, 2);

  return (
    <div className="sm:rounded-xl sm:p-6 sm:bg-main-light my-4">
      <h4>{category.name}</h4>
      {category.description && <p className="mt-2">{category.description}</p>}
      <div className="sm:hidden mt-6 lg:mt-5 outside-parent-container pl-4">
        <Swiper spaceBetween={8} slidesPerView={1.5} breakpoints={{ 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 2.5 } }}>
          {productsToDisplay.map((pid) => {
            const product = adviceResponseObject.products[pid];
            if (product) return <SwiperSlide key={uuidv4() + '-' + product.id}><Product product={product} /></SwiperSlide>;
          })}
        </Swiper>
      </div>
      <div className="hidden sm:block sm:rounded-md sm:overflow-hidden mt-6 lg:mt-5 divide-y divide-main-light">
        {visibleProducts.map((pid) => {
          const product = adviceResponseObject.products[pid];
          if (product) return <Product key={uuidv4() + '-' + product.id} product={product} />;
        })}
      </div>
      {productsToDisplay.length > 2 && (
        <button type="button" onClick={() => setIsOpen(!isOpen)} className="hidden sm:block text-lg underline text-secondary-orange cursor-pointer p-2 mt-4">
          {isOpen ? <i className="fas fa-minus mr-3" /> : <i className="fas fa-plus mr-3" />}
          Bekijk {isOpen ? 'minder' : 'alle'} producten
        </button>
      )}
    </div>
  );
};

export default Category;
